import React from 'react';

/**
 * PFM-3150: scoped to one outer MUI v4 dialog. A descendant MUI X picker reports
 * open/close via `setPickerOpen(boolean)` so the outer v4 trap can yield while the
 * picker's own v5 trap is active. `null` outside a providing dialog (no-op).
 * @type {React.Context<{ setPickerOpen: (isOpen: boolean) => void } | null>}
 */
const ActivePickerTrapContext = React.createContext(null);

export default ActivePickerTrapContext;
